import styled from 'styled-components'

export const H3 = styled.h3`
  color: ${props => props.theme.colors.gray1};
  font-weight: 600;
`
